export default __webpack_public_path__ + "newsletter.2285c05.png";